import { getFileTypeInfo } from '@/shared/constants/fileTypes'
import { cn } from '@/shared/lib/utils'
import CloseOutlined from '@mui/icons-material/CloseOutlined'
import React from 'react'
import type { FilePreviewProps } from './types'

export const FilePreview: React.FC<FilePreviewProps> = ({
  file,
  onRemove,
  variant = 'homepage',
}) => {
  const fileTypeInfo = getFileTypeInfo(file.name, file.type)
  const IconComponent = fileTypeInfo.icon
  const fileSizeKB = (file.size / 1024).toFixed(1)
  const fileSize =
    file.size > 1024 * 1024
      ? `${(file.size / 1024 / 1024).toFixed(1)} MB`
      : `${fileSizeKB} KB`

  return (
    <div
      className={cn(
        'flex items-center gap-2 rounded-lg px-2 py-1.5 text-xs',
        variant === 'dashboard' ? 'border bg-white' : 'border bg-gray-50'
      )}
    >
      <IconComponent className="h-3 w-3 shrink-0 text-gray-600" />
      <span
        className="min-w-0 flex-1 truncate font-medium text-gray-900"
        title={file.name}
      >
        {file.name}
      </span>
      <span className="text-gray-500">{fileSize}</span>
      <button
        type="button"
        onClick={onRemove}
        className="flex h-4 w-4 shrink-0 items-center justify-center rounded-full text-gray-400 hover:bg-gray-200 hover:text-gray-600"
        aria-label={`Remove ${file.name}`}
      >
        <CloseOutlined sx={{ fontSize: 12 }} />
      </button>
    </div>
  )
}
